<!--
  CWS-1779: the row actions menu, built from the server's per-row cancellation
  flags (buildOrderRowActions). "View details" is always first; Refund and Cancel
  name the item ("Refund single wash", "Cancel membership") and are greyed, with
  a hint, when the server says they do not apply.
-->
<div
  class="actions-dropdown-menu"
  *ngIf="openDropdownId && selectedOrder"
  [id]="'dropdown-' + openDropdownId"
  role="menu"
>
  <div
    *ngFor="let action of actions; trackBy: trackAction"
    class="dropdown-item"
    [class.dropdown-item--refund]="action.key === 'refund' || action.key === 'retry_refund'"
    [class.dropdown-item--cancel]="action.key === 'cancel'"
    [class.disabled]="!action.enabled"
    [attr.role]="'menuitem'"
    [attr.aria-disabled]="!action.enabled"
    [attr.data-action]="action.key"
    (click)="onAction(action)"
  >
    <div class="dropdown-content">
      <span class="dropdown-text">
        <span class="dropdown-label">{{ action.label }}</span>
        <!-- Why a greyed item is greyed: revealed on hover; always shown where the design draws it. -->
        <span
          class="dropdown-hint"
          *ngIf="!action.enabled && action.hint"
          [class.dropdown-hint--inline]="action.inlineHint"
          >{{ action.hint }}</span
        >
      </span>
      <!-- View details: an eye, as the design draws it. -->
      <svg
        *ngIf="action.key === 'view'"
        class="dropdown-icon"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        data-icon="eye"
      >
        <path
          d="M0.875 7C0.875 7 3.0625 2.625 7 2.625C10.9375 2.625 13.125 7 13.125 7C13.125 7 10.9375 11.375 7 11.375C3.0625 11.375 0.875 7 0.875 7Z"
          stroke="#555A63"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z"
          stroke="#555A63"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        *ngIf="action.key === 'cancel'"
        class="dropdown-icon"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M1.75 1.75L12.25 12.25"
          stroke="#DA1E28"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.25 1.75L1.75 12.25"
          stroke="#DA1E28"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        *ngIf="action.key === 'refund' || action.key === 'retry_refund'"
        class="dropdown-icon"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M5.25 3.5L2.33333 6.41667L5.25 9.33333"
          stroke="#555A63"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.33333 6.41667H9.04167C10.4914 6.41667 11.6667 7.59191 11.6667 9.04167V10.5"
          stroke="#555A63"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</div>
